import { z } from "zod";
export const ContentSyncOptionsSchema = z.object({
    content: z.boolean().default(true),
    translations: z.boolean().default(false),
    media: z.boolean().default(false),
});
export const ContentSyncCountSchema = z.object({
    total: z.number(),
    dev_to_prod: z.number(),
    prod_to_dev: z.number(),
    deleted: z.number().default(0),
});
export const ContentSyncResultSchema = z.object({
    courses: ContentSyncCountSchema,
    modules: ContentSyncCountSchema,
    exercises: ContentSyncCountSchema,
    categories: ContentSyncCountSchema,
    vocabWords: ContentSyncCountSchema,
    translations: z.object({
        words: ContentSyncCountSchema,
        sentences: ContentSyncCountSchema,
    }).optional(),
    media: z.object({
        copied_to_prod: z.number(),
        copied_to_dev: z.number(),
        skipped: z.number(),
    }).optional(),
    deletions: z.object({
        from_dev: z.number(),
        from_prod: z.number(),
        logs_synced: z.number(),
        logs_cleaned: z.number(),
    }).optional(),
    duration_ms: z.number(),
    errors: z.array(z.string()),
});
// ============================================================================
// PREVIEW / DRY-RUN TYPES
// ============================================================================
export const ContentSyncPreviewItemSchema = z.object({
    id: z.union([z.number(), z.string()]),
    name: z.string(),
    type: z.string(),
    updated_at: z.string().optional(),
});
export const ContentSyncPreviewGroupSchema = z.object({
    add: z.array(ContentSyncPreviewItemSchema),
    update: z.array(ContentSyncPreviewItemSchema),
    delete: z.array(ContentSyncPreviewItemSchema),
});
export const ContentSyncPreviewDirectionSchema = z.object({
    courses: ContentSyncPreviewGroupSchema,
    modules: ContentSyncPreviewGroupSchema,
    exercises: ContentSyncPreviewGroupSchema,
    categories: ContentSyncPreviewGroupSchema,
    vocabWords: ContentSyncPreviewGroupSchema,
});
export const ContentSyncDuplicateResolvedSchema = z.object({
    type: z.string(),
    slug: z.string(),
    devId: z.union([z.number(), z.string()]),
    prodId: z.union([z.number(), z.string()]),
    winner: z.enum(["dev", "prod"]),
});
export const ContentSyncPreviewResultSchema = z.object({
    toProd: ContentSyncPreviewDirectionSchema,
    toDev: ContentSyncPreviewDirectionSchema,
    duplicatesResolved: z.array(ContentSyncDuplicateResolvedSchema),
});
